import { render, staticRenderFns } from "./WaterAvailabilityChart.vue?vue&type=template&id=a5e88582"
import script from "./WaterAvailabilityChart.vue?vue&type=script&lang=js"
export * from "./WaterAvailabilityChart.vue?vue&type=script&lang=js"
import style0 from "./WaterAvailabilityChart.vue?vue&type=style&index=0&id=a5e88582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports